export default "__VITE_ASSET__BvCkMDbO__"